import { ShapeData } from 'data/FlyerData';
import { ShapeFrame } from 'data/ShapeFrame';
import { EDITED_SHAPE } from 'state/actions';
import { getFrameById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

export class ChangeShapeCommand extends Command {
  frameId: string;
  value: ShapeData;
  prevValue: ShapeData;
  constructor(frameId: string, value: ShapeData) {
    super();
    this.frameId = frameId;
    this.value = value;
    this.canMerge = true;
  }
  execute(firstTime?: boolean | undefined): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const frame = getFrameById(flyer, this.frameId);
      if (frame && frame instanceof ShapeFrame) {
        if (firstTime) {
          this.prevValue = frame.mask;
        }
        frame.mask = this.value;
        dispatch({ type: EDITED_SHAPE });
      }
    };
  }
  undo(): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const frame = getFrameById(flyer, this.frameId);
      if (frame && frame instanceof ShapeFrame) {
        frame.mask = this.prevValue;
        dispatch({ type: EDITED_SHAPE });
      }
    };
  }

  merge(nextCommand: Command): void {
    if (nextCommand instanceof ChangeShapeCommand) {
      this.value = nextCommand.value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/ChangeShapeCommand.ts